import React from 'react';
import 'twin.macro';
import { Small, TextLine } from '../text';
import { Icon } from '../icon';
import { CheckIcon } from 'icons';

export const SettingsItem = ({
  title,
  description,
  children,
  iconType = CheckIcon,
  fillcolor,
  noIcon = false,
}) => (
  <div tw='flex w-full gap-3 items-center justify-between pr-4 pl-2 mb-6 last:mb-0'>
    <div tw='flex w-full gap-3 items-center'>
      {!noIcon && <Icon Type={iconType} fillcolor={fillcolor} />}
      <div tw='flex flex-col flex-grow'>
        <TextLine text={title} bold />
        <Small text={description} tw='font-sans line-clamp-1 -mt-0.5' />
      </div>
      {children}
    </div>
  </div>
);
